import React from 'react';
import './LockedFeatureCard.css';

/**
 * LockedFeatureCard — shown in place of a feature (Coding, MCQ, Setup)
 * when the current user is on the FREE tier. Triggers the Fast Track
 * upsell popup rather than navigating anywhere.
 */
export default function LockedFeatureCard({ title, description, onUnlock }) {
  return (
    <div className="lfc-container">
      <div className="lfc-card">
        <span className="lfc-lock-icon">🔒</span>
        <h2>{title}</h2>
        <p>{description}</p>
        <button className="lfc-btn" onClick={onUnlock}>
          Unlock with Fast Track — ₹299
        </button>
      </div>
    </div>
  );
}
